import React, { useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { DUMMY_GAMES } from "../data/games_dummy";
import GameListing from "../components/games/gamelisting";

export default function GamesDetails() {
    const { slug } = useParams();

    const game = useMemo(() => {
        return DUMMY_GAMES.find((g) => g.slug === slug || String(g.id) === slug || g.sub_id === slug);
    }, [slug]);

    const similarGames = useMemo(() => {
        if (!game) return [];
        return DUMMY_GAMES.filter((g) => g.category === game.category && g.slug !== game.slug).slice(0, 4);
    }, [game]);
    const otherGames = useMemo(() => {
        if (!game) return [];
        return DUMMY_GAMES.filter((g) => g.slug !== game.slug).slice(0, 10);
    }, [game]);

    if (!game) {
        return (
            <section className="games-details">
                <style>{css}</style>
                <div className="gd-container">
                    <p className="gd-back"><Link to="/games">{" <- Back to Games"}</Link></p>
                    <h2 className="gd-title">Game not found</h2>
                    <p className="gd-muted">Please go back and pick a different game.</p>
                </div>
            </section>
        );
    }

    return (
        <section className="games-details">
            <style>{css}</style>
            <div className="">
                <p className="gd-back"><Link to="/games">{" <- Back to Games"}</Link></p>

                <div className="uk-grid uk-grid-custom" data-uk-grid="">
                    <div className="uk-width-3-4@l uk-width-3-5@m">
                        <div className="uk-grid uk-child-width-1-1@s">
                            <section className="b-post b-post-full b-post-single clearfix">
                                <div className="entry-media">
                                    <div className="gd-player">
                                        <iframe
                                            src={game.distribution_url}
                                            title={`${game.title} - Play`}
                                            loading="lazy"
                                            allow="fullscreen; autoplay; gamepad; clipboard-read; clipboard-write"
                                        />
                                    </div>
                                </div>

                                <div className="entry-main">
                                    <div className="gd-section">
                                        <h3>{game.title}</h3>
                                        <div className="gd-meta">
                                            <span className="gd-tag">{game.category}</span>
                                            <span className="gd-sep">•</span>
                                            <span className="gd-type">{game.type}</span>
                                            <span className="gd-sep">•</span>
                                            <span className="gd-votes">{game.votes} votes</span>
                                        </div>
                                    </div>
                                    <div className="gd-section">
                                        <h3>Description</h3>
                                        <p>{game.description || "No description available."}</p>
                                    </div>
                                    <div className="gd-section">
                                        <h3>Instructions</h3>
                                        <p>{game.instructions || "No instructions provided."}</p>
                                    </div>

                                    <div className="gd-section">
                                        <h3>Other Games</h3>
                                        <GameListing games={otherGames} />
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>

                    <div className="uk-width-1-5@l uk-width-2-5@m">
                        <aside className="">
                            <section className="">
                                <h3 className="">
                                     Similar Games
                                </h3>
                                <div className="widget-content">
                                    <div className="gd-similar-grid">
                                        {similarGames.map((item) => (
                                            <Link
                                                key={item.slug || item.id}
                                                to={`/games/${item.slug || item.id}`}
                                                className="gd-similar-card"
                                            >
                                                <img src={item.image} alt={item.title} />
                                                <div className="gd-similar-name">{item.title}</div>
                                            </Link>
                                        ))}
                                        {similarGames.length === 0 && (
                                            <div className="gd-muted">No similar games found.</div>
                                        )}
                                    </div>
                                </div>
                            </section>
                        </aside>
                    </div>
                </div>
            </div>
        </section>
    );
}

const css = `
.games-details {
  padding: 36px 0 70px;
}
.gd-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
}
.gd-back a {
  color: var(--heading-color, #fff);
  text-decoration: none;
  font-weight: 700;
}
.gd-title {
  font-size: clamp(24px, 3vw, 40px);
  text-transform: uppercase;
  letter-spacing: 1px;
}
.gd-meta {
  display: flex;
  gap: 10px;
  align-items: center;
  color: rgba(255,255,255,.7);
  font-size: 13px;
}
.gd-tag {
  background: rgba(249,115,22,.9);
  color: #0b0b0b;
  padding: 3px 10px;
  border-radius: 999px;
  font-weight: 800;
}
.gd-player {
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(255,255,255,.08);
  background: #0b0b0b;
  margin-top: 10px;
}
.gd-player iframe {
  width: 100%;
  height: clamp(320px, 55vw, 640px);
  border: 0;
  display: block;
}
.gd-section {
  margin: 20px 0;
  background: rgba(255,255,255,.03);
  border: 1px solid rgba(255,255,255,.08);
  padding: 16px 18px;
  border-radius: 12px;
}
.gd-section h3 {
  margin: 0 0 8px;
}
.gd-section p {
  margin: 0;
  color: rgba(255,255,255,.8);
  font-size: 14px;
}
.gd-similar-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 12px;
}
.gd-similar-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-decoration: none;
  color: #fff;
  background: #101010;
  border: 1px solid rgba(255,255,255,.08);
  border-radius: 10px;
  overflow: hidden;
  transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease;
}
.gd-similar-card:hover {
  transform: translateY(-2px);
  border-color: rgba(249,115,22,.6);
  box-shadow: 0 8px 20px rgba(0,0,0,.5);
}
.gd-similar-card img {
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
}
.gd-similar-name {
  font-size: 12px;
  font-weight: 700;
  padding: 0 8px 8px;
  text-transform: uppercase;
  letter-spacing: .4px;
}
.gd-muted {
  color: rgba(255,255,255,.7);
  font-size: 13px;
  padding: 10px 4px;
}
`;
